import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const leaders = [
  {
    name: "M. Venugopal",
    role: "Chief Executive Officer",
    experience: "18+ Years",
    image:
      "https://res.cloudinary.com/dtuqzt18e/image/upload/v1786863284/rgv_rfyxcv.jpg",

    intro:
      "M. Venugopal, Chief Executive Officer of Sri Veera Raghavendra Hardware, Plywood, is a seasoned entrepreneur with over 18 years of experience in the building materials industry, having started his business journey in 2008.",

    fullContent: [
      "With extensive knowledge of PVC doors, wooden doors, door hardware, plywood, construction materials, and interior building solutions, he has built a strong reputation for quality, reliability, and customer satisfaction.",

      "Under his leadership, Raghavendra Doors has grown into a trusted destination for PVC and wooden doors, premium door hardware, plywood, and construction materials. The company serves homeowners, builders, architects, interior designers, contractors, and commercial projects.",

      "M. Venugopal believes in delivering the right products at competitive prices while providing expert product guidance, dependable service, and quality-focused solutions. His customer-first approach has helped establish long-term relationships and strengthen the company’s presence in the building materials and doors industry.",

      "With a vision for continuous growth and excellence, he continues to lead Sri Veera Raghavendra Hardware, Plywood toward becoming a trusted name for doors, hardware, plywood, and complete building material solutions.",
    ],

    quote:
      "Build with Quality. Serve with Integrity. Earn Trust for a Lifetime.",
  },

  {
    name: "Koushik Mattapalli",
    role: "Managing Director",
    degree: "B.Tech",
    experience: "2+ Years",
    image:
      "https://res.cloudinary.com/dtuqzt18e/image/upload/v1782882434/ChatGPT_Image_Jul_1_2026_10_35_34_AM_lzy1rw.png",

    intro:
      "Koushik Mattapalli, Managing Director of Sree Veera Raghavendra Door & Plywood, is a B.Tech graduate with over 2 years of professional experience and a strong passion for business, building materials, and customer-focused solutions.",

    fullContent: [
      "Coming from a family with a strong business foundation, Koushik entered the industry with a vision to carry forward his family’s legacy while bringing a modern and professional approach to the business. His combination of technical knowledge, market understanding, and entrepreneurial mindset enables him to contribute effectively to the company’s continued growth.",

      "As Managing Director, he actively oversees day-to-day operations, business development, customer relationships, product management, and growth initiatives. He is committed to ensuring customers receive quality products, competitive pricing, professional guidance, and dependable service.",

      "Under his leadership, Sree Veera Raghavendra Door & Plywood continues to strengthen its presence in PVC doors, wooden doors, plywood, premium door hardware and building material solutions, serving homeowners, builders, architects, interior designers, contractors, and commercial clients.",

      "Koushik’s vision is to combine the trust and values built by the previous generation with modern business practices, innovation, and professional management. He is focused on expanding the company’s reach while maintaining its commitment to quality, customer satisfaction, and long-term relationships.",

      "With a strong foundation, fresh ideas, and a forward-looking vision, Koushik Mattapalli is committed to taking Sree Veera Raghavendra Door & Plywood to greater heights and building it into a trusted, professional, and recognized brand in the doors and building materials industry.",
    ],

    quote:
      "Combining a trusted family legacy with modern business practices, innovation, and professional management.",
  },
];

export default function Leadership() {
  const [expanded, setExpanded] = useState({});

  const toggleView = (index) => {
    setExpanded((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <section className="leadership-section">
      <style>{`
        .leadership-section {
          background: #f8f8f8;
          padding: 100px 0;
          overflow: hidden;
        }

        /* HEADER */

        .leadership-header {
          max-width: 760px;
          margin: 0 auto 75px;
          text-align: center;
        }

        .leadership-label {
          color: #f97316;
          font-size: 13px;
          font-weight: 800;
          letter-spacing: 3px;
          text-transform: uppercase;
          margin-bottom: 15px;
        }

        .leadership-title {
          margin: 0 0 18px;
          color: #171717;
          font-size: clamp(2.2rem, 4vw, 3.6rem);
          line-height: 1.1;
          font-weight: 800;
        }

        .leadership-title span {
          color: #f97316;
        }

        .leadership-subtitle {
          color: #666;
          font-size: 1.05rem;
          line-height: 1.8;
          margin: 0;
        }

        /* LEADERSHIP CARD */

        .leader-card {
          display: flex;
          width: 100%;
          background: #fff;
          border-radius: 28px;
          overflow: hidden;
          box-shadow: 0 20px 55px rgba(0, 0, 0, 0.09);
          margin-bottom: 70px;
          min-height: 620px;
        }

        .leader-card.reverse {
          flex-direction: row-reverse;
        }

        /* IMAGE */

        .leader-image-side {
          width: 45%;
          min-height: 620px;
          position: relative;
          overflow: hidden;
          background: #eee;
          flex-shrink: 0;
        }

        .leader-image {
          width: 100%;
          height: 100%;
          position: absolute;
          inset: 0;
          object-fit: cover;
          object-position: center top;
          transition: transform 0.8s ease;
        }

        .leader-card:hover .leader-image {
          transform: scale(1.035);
        }

        .leader-image-overlay {
          position: absolute;
          inset: auto 0 0;
          padding: 100px 32px 30px;
          background: linear-gradient(
            to top,
            rgba(0, 0, 0, 0.75),
            rgba(0, 0, 0, 0)
          );
        }

        .leader-image-name {
          color: #fff;
          font-size: 1.45rem;
          font-weight: 800;
          margin-bottom: 5px;
        }

        .leader-image-role {
          color: #f97316;
          font-size: 0.82rem;
          font-weight: 800;
          letter-spacing: 2px;
          text-transform: uppercase;
        }

        /* CONTENT */

        .leader-content-side {
          width: 55%;
          padding: 55px 60px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .leader-role {
          color: #f97316;
          font-size: 12px;
          font-weight: 800;
          letter-spacing: 3px;
          text-transform: uppercase;
          margin-bottom: 10px;
        }

        .leader-name {
          color: #171717;
          font-size: clamp(2rem, 3vw, 3.1rem);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 10px;
        }

        .leader-name span {
          color: #f97316;
        }

        .leader-degree {
          color: #777;
          font-size: 0.95rem;
          font-weight: 600;
          margin-bottom: 18px;
        }

        /* EXPERIENCE */

        .experience-pill {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          width: fit-content;
          background: #fff7ed;
          border: 1px solid #fed7aa;
          border-radius: 50px;
          padding: 9px 17px;
          margin-bottom: 22px;
        }

        .experience-number {
          color: #f97316;
          font-size: 1.15rem;
          font-weight: 800;
        }

        .experience-text {
          color: #555;
          font-size: 0.82rem;
          font-weight: 600;
        }

        /* TEXT */

        .leader-text {
          color: #5c5c5c;
          font-size: 0.98rem;
          line-height: 1.78;
          margin-bottom: 15px;
        }

        /* VIEW MORE */

        .view-more-wrapper {
          margin-top: 5px;
          margin-bottom: 18px;
        }

        .view-more-btn {
          display: inline-flex;
          align-items: center;
          gap: 9px;
          padding: 10px 0;
          border: none;
          background: transparent;
          color: #f97316;
          font-size: 0.9rem;
          font-weight: 800;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .view-more-btn:hover {
          color: #ea580c;
          gap: 13px;
        }

        .view-more-arrow {
          font-size: 17px;
          transition: transform 0.3s ease;
        }

        .view-more-btn.active .view-more-arrow {
          transform: rotate(180deg);
        }

        /* QUOTE */

        .leader-quote {
          position: relative;
          background: #fafafa;
          border-left: 4px solid #f97316;
          border-radius: 0 14px 14px 0;
          padding: 20px 23px;
          margin-top: 8px;
        }

        .leader-quote::before {
          content: "“";
          position: absolute;
          top: 4px;
          left: 13px;
          color: #f97316;
          font-size: 34px;
          font-weight: 800;
          line-height: 1;
        }

        .leader-quote p {
          margin: 0;
          padding-left: 18px;
          color: #555;
          font-size: 0.92rem;
          line-height: 1.7;
          font-style: italic;
        }

        /* DIVIDER */

        .leadership-divider {
          width: 70px;
          height: 4px;
          background: #f97316;
          border-radius: 20px;
          margin: 0 auto 70px;
        }

        /* TABLET */

        @media (max-width: 991px) {
          .leadership-section {
            padding: 80px 0;
          }

          .leader-card,
          .leader-card.reverse {
            flex-direction: column;
            min-height: auto;
          }

          .leader-image-side {
            width: 100%;
            height: 500px;
            min-height: 500px;
          }

          .leader-content-side {
            width: 100%;
            padding: 45px 40px 50px;
          }
        }

        /* MOBILE */

        @media (max-width: 575px) {
          .leadership-section {
            padding: 65px 0;
          }

          .leadership-header {
            margin-bottom: 45px;
          }

          .leadership-title {
            font-size: 2.25rem;
          }

          .leadership-subtitle {
            font-size: 0.95rem;
          }

          .leader-card {
            border-radius: 20px;
            margin-bottom: 55px;
          }

          .leader-image-side {
            height: 390px;
            min-height: 390px;
          }

          .leader-image-overlay {
            padding: 80px 22px 22px;
          }

          .leader-image-name {
            font-size: 1.2rem;
          }

          .leader-content-side {
            padding: 32px 22px 35px;
          }

          .leader-name {
            font-size: 2.15rem;
          }

          .leader-text {
            font-size: 0.94rem;
            line-height: 1.75;
          }

          .leader-quote {
            padding: 18px 18px;
          }
        }
      `}</style>

      <div className="container">

        {/* SECTION HEADER */}
        <motion.div
          className="leadership-header"
          initial={{ opacity: 0, y: 25 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="leadership-label">
            Our Leadership
          </div>

          <h2 className="leadership-title">
            Experience That <span>Builds Trust</span>
          </h2>

          <p className="leadership-subtitle">
            Guided by experience, family values, and a forward-looking
            vision, our leadership continues to build a trusted name in
            doors and building materials.
          </p>
        </motion.div>

        {/* LEADERS */}
        {leaders.map((leader, index) => {
          const isExpanded = expanded[index];

          return (
            <React.Fragment key={leader.name}>

              <motion.div
                className={`leader-card ${
                  index % 2 !== 0 ? "reverse" : ""
                }`}
                initial={{
                  opacity: 0,
                  y: 50,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0,
                }}
                viewport={{
                  once: true,
                  margin: "-80px",
                }}
                transition={{
                  duration: 0.75,
                }}
              >

                {/* IMAGE */}
                <div className="leader-image-side">

                  <img
                    src={leader.image}
                    alt={`${leader.name} - ${leader.role}`}
                    className="leader-image"
                  />

                  <div className="leader-image-overlay">
                    <div className="leader-image-name">
                      {leader.name}
                    </div>

                    <div className="leader-image-role">
                      {leader.role}
                    </div>
                  </div>

                </div>

                {/* CONTENT */}
                <div className="leader-content-side">

                  <div className="leader-role">
                    {leader.role}
                  </div>

                  <h3 className="leader-name">
                    {leader.name}
                  </h3>

                  {leader.degree && (
                    <div className="leader-degree">
                      {leader.degree} · Building Materials & Business
                    </div>
                  )}

                  <div className="experience-pill">
                    <span className="experience-number">
                      {leader.experience}
                    </span>

                    <span className="experience-text">
                      Professional Experience
                    </span>
                  </div>

                  {/* INTRO */}
                  <p className="leader-text">
                    {leader.intro}
                  </p>

                  {/* VIEW MORE CONTENT */}
                  <AnimatePresence initial={false}>
                    {isExpanded && (
                      <motion.div
                        initial={{
                          height: 0,
                          opacity: 0,
                        }}
                        animate={{
                          height: "auto",
                          opacity: 1,
                        }}
                        exit={{
                          height: 0,
                          opacity: 0,
                        }}
                        transition={{
                          duration: 0.4,
                          ease: "easeInOut",
                        }}
                        style={{
                          overflow: "hidden",
                        }}
                      >
                        {leader.fullContent.map(
                          (paragraph, paragraphIndex) => (
                            <p
                              className="leader-text"
                              key={paragraphIndex}
                            >
                              {paragraph}
                            </p>
                          )
                        )}
                      </motion.div>
                    )}
                  </AnimatePresence>

                  {/* VIEW MORE BUTTON */}
                  <div className="view-more-wrapper">
                    <button
                      type="button"
                      className={`view-more-btn ${
                        isExpanded ? "active" : ""
                      }`}
                      onClick={() => toggleView(index)}
                    >
                      {isExpanded ? "View Less" : "View More"}

                      <span className="view-more-arrow">
                        ↓
                      </span>
                    </button>
                  </div>

                  {/* QUOTE */}
                  <div className="leader-quote">
                    <p>{leader.quote}</p>
                  </div>

                </div>

              </motion.div>

              {index === 0 && (
                <div className="leadership-divider" />
              )}

            </React.Fragment>
          );
        })}

      </div>
    </section>
  );
}